interface IStorageItem {
    clear(): void;
    getItem(key: string): string | null;
    setItem(key: string, value: string): void;
}

export class Storage {
    private readonly storageType: IStorageItem;

    public constructor(storageType: IStorageItem) {
        this.storageType = storageType;
    }

    public clear = () => {
        this.storageType.clear();
    };

    public load = <T>(key: string): T => {
        try {
            let serializesState = this.storageType.getItem(key);

            if (!serializesState) {
                serializesState = JSON.stringify({});
            }

            return JSON.parse(serializesState);
        } catch (err) {
            return JSON.parse("");
        }
    };

    public save = <T>(key: string, state: T) => {
        try {
            const serializesState = JSON.stringify(state);
            this.storageType.setItem(key, serializesState);
        } catch (err) {
            return;
        }
    };
}
